// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"LeaderboardsPage_pageContainer__1Kfkq","icons":"LeaderboardsPage_icons__kp5Hp","emptyContainer":"LeaderboardsPage_emptyContainer__1qi7j"};